<template>
    <DCard
        padding
    >
        <Form
            :dwh-settings="dwhSettings"
            :errors="errors"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script>
import Form from '~@/Components/Settings/DwhSettings/Form'

export default {
    name: 'DwhSettingsCreate',
    components: {
        Form
    },
    props: {
        dwhSettings: {
            type: Object,
            default () {
                return {}
            }
        },
        errors: {
            type: Object,
            default () {
                return {}
            }
        }
    },
    methods: {
        submitData (form) {
            form.post(this.$route('settings.dwh-settings.store'))
        }
    }
}
</script>
